import { FC } from "react";
import { ButtonPropTypes, ButtonIcon } from "./model";
import { ReactComponent as SaveIcon } from "@/assets/icons/save.svg";
import { ReactComponent as SyncIcon } from "@/assets/icons/sync.svg";
import { ReactComponent as SettingIcon } from "@/assets/icons/settings.svg";
import { ReactComponent as PlusIcon } from "@/assets/icons/plus.svg";
import { ReactComponent as EditIcon } from "@/assets/icons/edit.svg";
import { ReactComponent as ArrowLeftIcon } from "@/assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRightIcon } from "@/assets/icons/arrow-right.svg";
import "./style.scss";

const Button: FC<ButtonPropTypes> = ({
  onClick,
  label,
  size = "md",
  type = "primary",
  disabled = false,
  startIcon,
  endIcon,
  style,
  loading = false,
}) => {
  const getIcons = (buttonIcon: ButtonIcon) => {
    switch (buttonIcon) {
      case "save":
        return <SaveIcon />;
      case "sync":
        return <SyncIcon />;
      case "setting":
        return <SettingIcon />;
      case "plus":
        return <PlusIcon />;
      case "edit":
        return <EditIcon />;
      case "arrowLeft":
        return <ArrowLeftIcon />;
      case "arrowRight":
        return <ArrowRightIcon />;
    }
  };

  return (
    <button
      style={style}
      onClick={onClick}
      className={`btn-item ${type} ${size} ${type} ${disabled ? "disabled" : ""}`}>
      {loading ? (
        <i
          className={`fa fa-circle-o-notch fa-spin fa-${size} btn-label ${
            size === "md" ? "" : size
          } ${type}`}></i>
      ) : (
        <>
          {getIcons(startIcon ?? "")}
          <div
            className={`btn-label ${size === "md" ? "" : size} ${type}  ${
              disabled ? "disabled" : ""
            }`}>
            {label}
          </div>
          {getIcons(endIcon ?? "")}
        </>
      )}
    </button>
  );
};

export default Button;
